import request from '@/utils/request'

export function page(data) {
  return request({
    url: '/mg/daohang-member-api/memberType/page',
    method: 'post',
    data,
  })
}

export function list(data) {
  return request({
    url: '/mg/daohang-member-api/memberType/list',
    method: 'post',
    data,
  })
}

export function detail(id) {
  return request({
    url: `/mg/daohang-member-api/memberType/${id}`,
    method: 'get',
  })
}

export function save(data) {
  return request({
    url: '/mg/daohang-member-api/memberType',
    method: 'put',
    loading: true,
    data,
  })
}

export function updateStatus(data) {
  return request({
    url: '/mg/daohang-member-api/memberType/editStatus',
    method: 'post',
    loading: true,
    data,
  })
}
